import { HomeUsePluginUtil } from "@uikit/util/HomeUsePluginUtil";
import { useEffect } from "react";

function listener(event) {
  if (HomeUsePluginUtil.hasProjectModified()) {
    event.preventDefault();
    event.returnValue = "";
  }
}

const useAlertBeforeUnload = (showNavPage = false, isShare = false, needSave = true) => {
  useEffect(() => {
    if (needSave && !showNavPage && !isShare) {
      window.addEventListener("beforeunload", listener);
    } else {
      window.removeEventListener("beforeunload", listener);
    }
    return () => {
      window.removeEventListener("beforeunload", listener);
    };
  }, [needSave, showNavPage]);
};

export default useAlertBeforeUnload;
